import { CheckCircleFilled } from "@ant-design/icons"
import { Col, Select, Typography } from "antd"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import React, { useEffect } from "react"
import { db } from "../../../firebase/config"
import CreateTapeClient from "../../Clients/CreateTapeClient"
import CreateLeadPopup from "../../Clients/CreateLeadPopup"

const { Text } = Typography
const { Option } = Select

export default function SelectClient({
  selectedClient,
  handleClient,
  loadingClients,
  clients,
  setClients,
  setLoadingClients,
  user,
  selectedMachine,
  admin,
  semiAdmin,
  devSpecialist,
}) {
  useEffect(() => {
    setLoadingClients(true)

    // --- CLIENTS ---
    const clientsRef = collection(db, "clients")
    let clientsQ = query(clientsRef, where("user", "==", user.uid))
    if (admin || semiAdmin || devSpecialist) {
      clientsQ = query(clientsRef)
    }

    const unsubClients = onSnapshot(clientsQ, (snapshot) => {
      let clientResults = []
      snapshot.docs.forEach((doc) => {
        clientResults.push({ ...doc.data(), id: doc.id, type: "client" })
      })

      // filter for non-tape machines
      if (selectedMachine === "Tape" || selectedMachine === "Signal") {
        setClients((prev) => {
          const leadsOnly = prev.filter((x) => x.type === "lead") // keep existing leads
          return [...leadsOnly, ...clientResults]
        })
      } else {
        const filtered = clientResults.filter((res) => res.approved === true)
        setClients((prev) => {
          const leadsOnly = prev.filter((x) => x.type === "lead")
          return [...leadsOnly, ...filtered]
        })
      }

      setLoadingClients(false)
    })

    // --- LEADS ---
    const leadsRef = collection(db, "leads")
    let leadsQ = query(leadsRef, where("user", "==", user.uid))
    if (admin || semiAdmin || devSpecialist) {
      leadsQ = query(leadsRef)
    }

    const unsubLeads = onSnapshot(leadsQ, (snapshot) => {
      let leadResults = []
      snapshot.docs.forEach((doc) => {
        leadResults.push({ ...doc.data(), id: doc.id, type: "lead" })
      })

      setClients((prev) => {
        const clientsOnly = prev.filter((x) => x.type === "client")
        return [...clientsOnly, ...leadResults]
      })

      setLoadingClients(false)
    })

    return () => {
      unsubClients()
      unsubLeads()
    }
  }, [setClients, setLoadingClients, user, selectedMachine, admin, semiAdmin, devSpecialist])

  //correct layout
  if (selectedMachine === "Tape" || selectedMachine === "Signal") {
    // if tape, allows to create a client
    return (
      <>
        <Col span={10}>
          <Text>
            Client {selectedClient === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
          </Text>
        </Col>
        <Col span={12}>
          <Select
            style={{ width: "100%" }}
            onChange={handleClient}
            loading={loadingClients}
            placeholder="Client"
            showSearch
            value={selectedClient && selectedClient}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {clients &&
              clients.map((client, id) => (
                <Option id={client.id} key={id} profit={client.profitability} value={client.client}>
                  {client.client}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={2}>
          <CreateTapeClient icon={true} />
        </Col>
      </>
    )
  } else {
    // else normal layout
    return (
      <>
        <Col span={10}>
          <Text>
            Client {selectedClient === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
          </Text>
        </Col>
        <Col span={12}>
          <Select
            style={{ width: "100%" }}
            onChange={handleClient}
            loading={loadingClients}
            placeholder="Client"
            showSearch
            value={selectedClient && selectedClient}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {clients &&
              clients.map((client, id) => (
                <Option
                  id={client.id}
                  key={id}
                  profit={client.profitability}
                  lead={client.lead ? true : false}
                  value={client.client}>
                  {client.client}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={2}>
          <CreateLeadPopup icon={true} />
        </Col>
      </>
    )
  }
}
